import styled from 'styled-components';

export const WrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  height: 50vh;
  width: 80vw;
  overflow-y: auto;
  margin-top: 50px;
`;
